import React from 'react'

const Error = ({message}) => {
  return (
    <div>
      {message}
    </div>
  )
}

export default Error
